import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, LogOut } from "lucide-react";
import TopBar from "@/components/TopBar";
import SuppliersPanel from "@/components/finance/SuppliersPanel";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";

/**
 * Standalone Suppliers page accessible from the Admin dashboard (next to
 * Paramètres). The Suppliers referential lives at the company level and is
 * read by Finance (expenses) AND Ops (product catalog). Hosting it under
 * /admin (instead of nested in Finance tabs) makes that ownership explicit.
 */
export default function AdminSuppliers() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const canMutate = user?.role === "super_admin" || user?.role === "admin";

  const handleLogout = async () => { await logout(); navigate("/"); };

  return (
    <div className="min-h-screen bg-[#FFF9FB] pb-24" data-testid="admin-suppliers-page">
      <TopBar />
      <div className="max-w-6xl mx-auto px-5 pt-6">
        <button
          onClick={() => navigate("/admin")}
          data-testid="suppliers-back"
          className="inline-flex items-center gap-2 text-sm text-[#5C4664] hover:text-[#2A0E3C] mb-4"
        >
          <ArrowLeft className="w-4 h-4" /> Tableau de bord
        </button>

        <div className="flex items-end justify-between flex-wrap gap-3 mb-7">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#D81B8C] mb-2">
              Référentiel Milkado
            </p>
            <h1 className="font-display text-3xl sm:text-4xl font-black text-[#2A0E3C]">
              Fournisseurs
            </h1>
            <p className="mt-2 text-sm text-[#5C4664] max-w-2xl">
              Catalogue central des fournisseurs Milkado. Utilisé par le catalogue
              produits (Opérations) et le module de dépenses (Finances) pour les
              rapports consolidés « total dépense par fournisseur ».
            </p>
          </div>
          <Button
            variant="outline"
            onClick={handleLogout}
            data-testid="suppliers-logout"
            className="rounded-full border-[#F2E2EC] gap-2"
          >
            <LogOut className="w-4 h-4" /> Déconnexion
          </Button>
        </div>

        <SuppliersPanel canMutate={canMutate} />
      </div>
    </div>
  );
}
